import { axios, BaseApiUrl} from '../axios_config';

//PC装车 备货任务信息
export const GetWaitPutOnCarList = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/GetWaitPutOnCarList`, params);
};

//箱子信息
export const GetWaitPutOnCarBoxList = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/GetWaitPutOnCarBoxList`, params);
};

//提交
export const PutOnCarSubmit = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/PutOnCarSubmit`, params);
};


// 扫描装车箱码
export const ScanCodeDeliveryBox = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/ScanCodeDeliveryBox`, { ...params }).then(res => res.data);
}


///获取装车司机信息
export function GetPutCarDriverInfo(params) {
    return axios.get(`${BaseApiUrl}/PutOnCar/GetPutCarDriverInfo`, { params: params }).then(res => res.data);
 }

// 装车司机信息保存
export const SavePutCarDriverInfo = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/SavePutCarDriverInfo`, { ...params }).then(res => res.data);
}

// 装车图片
export const GetPutOnCarLoadingReviewImageListType = params =>{
    return axios.post(`${BaseApiUrl}/PutOnCar/GetPutOnCarLoadingReviewImageListType`, { ...params }).then(res => res.data);
}